// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"270":"resumen","277":"estadisticas","692":"view","934":"plotly"}[chunkId] + "." + {"270":"423856ad","277":"db93eadc","692":"26e0d4e6","934":"a738355f"}[chunkId] + ".css";
};